/*
* Custom JS
* Add custom javascript here!
*/
var theme = theme || {};

theme.Modals = (function() {
  function Modal(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active',
      closingClass: 'modal--is-closing',
      bodyOpenClass: 'modal-open',
      bodyOpenSolidClass: 'modal-open--solid',
      bodyClosingClass: 'modal-closing',
      closeOffContentClick: true
    };

    this.id = id;
    this.$modal = $('#' + id);

    if (!this.$modal.length) {
      return false;
    }

    this.nodes = {
      $parent: $('html').add('body'),
      $modalContent: this.$modal.find('.modal__inner')
    };

    this.config = $.extend(defaults, options);
    this.modalIsOpen = false;
    this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
    this.isSolid = this.config.solid;

    this.init();
  }

  Modal.prototype.init = function() {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');

    $(this.config.open).on('click', this.open.bind(this));
    this.$modal.find(this.config.close).on('click', this.close.bind(this));

    // Close modal if a drawer is opened
    $('body').on('drawerOpen', function() {
      this.close();
    }.bind(this));
  };

  Modal.prototype.open = function(evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget).attr('aria-expanded', 'true');
    }

    if (this.modalIsOpen && !externalCall) {
      this.close();
    }

    this.$modal
      .prepareTransition()
      .addClass(this.config.openClass);
    this.nodes.$parent.addClass(this.config.bodyOpenClass);

    if (this.isSolid) {
      this.nodes.$parent.addClass(this.config.bodyOpenSolidClass);
    }

    this.modalIsOpen = true;

    theme.a11y.trapFocus({
      $container: this.$modal,
      $elementToFocus: this.$focusOnOpen,
      namespace: 'modal_focus'
    });

    $('body')
      .trigger('productModalOpen')
      .trigger('modalOpen.' + this.id);

    this.bindEvents();
  };

  Modal.prototype.close = function() {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    this.$modal
      .prepareTransition()
      .removeClass(this.config.openClass)
      .addClass(this.config.closingClass);
    this.nodes.$parent.removeClass(this.config.bodyOpenClass);
    this.nodes.$parent.addClass(this.config.bodyClosingClass);
    window.setTimeout(function() {
      this.nodes.$parent.removeClass(this.config.bodyClosingClass);
      this.$modal.removeClass(this.config.closingClass);
      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'false').focus();
      }
    }.bind(this), 500); // modal close css transition

    if (this.isSolid) {
      this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass);
    }

    this.modalIsOpen = false;

    theme.a11y.removeTrapFocus({
      $container: this.$modal,
      namespace: 'modal_focus'
    });

    $('body').trigger('modalClose.' + this.id);

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function() {
    // Pressing escape closes modal
    this.nodes.$parent.on('keyup.modal', function(evt) {
      if (evt.keyCode === 27) {
        this.close();
      }
    }.bind(this));

    if (this.config.closeOffContentClick) {
      // Clicking outside of the modal content also closes it
      this.$modal.on('click.modal', this.close.bind(this));

      // Exception to above: clicking anywhere on the modal content will NOT close it
      this.nodes.$modalContent.on('click.modal', function(evt) {
        evt.stopImmediatePropagation();
      });
    }
  };

  Modal.prototype.unbindEvents = function() {
    this.nodes.$parent.off('.modal');

    if (this.config.closeOffContentClick) {
      this.$modal.off('.modal');
      this.nodes.$modalContent.off('.modal');
    }
  };

  return Modal;
})();

document.addEventListener('DOMContentLoaded', event => {
  var initUploader = function() {
    const $modal = new theme.Modals('upload-modal', 'upload-modal', {
      solid: true
    });
    const $uploadCropper = $('#upload-cropper').croppie({
      viewport: {
        width: 300,
        height: 300,
        type: 'circle'
      },
      boundary: {
        width: 300,
        height: 300
      },
      enforceBoundary: false,
      enableExif: true,
    });

    $('#upload-file').on('change', function () {
      readFileUpload(this, function (e) {
        $uploadCropper.croppie('bind', {
          url: e.target.result
        });
        $modal.open();
      });
      // Reset field so if customer reselects the same file we can rerun crop UI.
      $(this).replaceWith($(this).val('').clone(true));
    });

    $('#upload-preview').on('load', function () {
      $(this).parent().removeClass('upload__preview-wrap--loading');
    })

    $('#upload-save').on('click', function () {
      $(this)
        .text('Uploading…')
        .prop('disabled', true)
        .addClass('btn--no-animate');

      $uploadCropper.croppie('result', {
        type: 'base64',
        circle: true,
        format: 'jpeg',
        size: 'original',
      }).then(function (croppedImage) {
        croppedImage.lastModifiedDate = new Date();
        croppedImage.name = 'extra.jpg';
        $.ajax({
          url: 'https://photoapi.clouduploadkit.com/images/do_upload',
        type: 'POST',
        dataType: 'JSON',
        data: {
            base64data : croppedImage
          }
        }).done(function (response) {
          if(response.status){
          $('#upload-preview')
            .attr('src', response.img_url)
            .addClass('upload__preview--active');
          $('#upload-preview')
            .parent()
            .addClass('upload__preview-wrap--loading');
          $('#upload-property').val(response.img_url);
          $modal.close();
          $('#upload-save')
            .text('Save & Upload')
            .prop('disabled', false)
            .removeClass('btn--no-animate');
          }else{
            alert(response.message);
          }
        });
      });
    });
  }

  var readFileUpload = function(input, loadCallback) {
    if (input.files && input.files[0]) {
      var reader = new FileReader();
      reader.onload = loadCallback;
      reader.readAsDataURL(input.files[0]);
    } else {
      alert("Sorry, your browser doesn't support uploads here.");
    }
  }

  initUploader();
});

/** EVENTS
 * Product Form
 * document.addEventListener('product:form:loaded', (event) => {
 *   let variant = event.detail.variant; // Give you the default selected variant
 *   let formElement = event.target;
 *   console.log(variant, formElement)
 * });
 *
 *
 */
